<template>
  <div class="dynamic">
    <el-form :model="dynamicForm" ref="dynamicFormRef" label-width="140px" :disabled="isDisabled">
      <el-row :gutter="20" v-for="(item, index) of dynamicForm.dynamicList" :key="index">
        <el-col :span="8">
          <el-form-item
            :prop="`dynamicList.${index}.${key1}`"
            :label="`第${index + 1}次${text1Message}`"
            :rules="[
              { required: isRequiredKey1, message: `请输入${text1Message}`, trigger: 'blur' },
              { validator: isNumberValidator, trigger: ['blur', 'change'] },
            ]"
          >
            <el-input v-model="item[key1]" :placeholder="`请输入${text1Message}`">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :prop="`dynamicList.${index}.${key2}`"
            :label="`${text2Message}`"
            :rules="[
              { required: isRequiredKey2, message: `请输入${text2Message}`, trigger: 'blur' },
              { validator: isNumberValidator, trigger: ['blur', 'change'] },
            ]"
          >
            <el-input v-model="item[key2]" :placeholder="`请输入${text2Message}`">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-if="!isDisabled">
          <el-button type="danger" @click="deleteItem(item)">删除</el-button>
        </el-col>
      </el-row>
      <el-row v-if="!isDisabled">
        <el-form-item>
          <el-button @click="addItem" type="primary">新增</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- <el-button @click="submitHandler">提交</el-button> -->
  </div>
</template>

<script>
  import { isNumberValidator } from '@/validators';
  export default {
    name: 'DynamicForm',
    props: {
      // 字段一的文本
      text1Message: {
        type: String,
        default: '回款比例',
      },
      text2Message: {
        type: String,
        default: '回款提醒',
      },
      // 字段一的key
      key1: {
        type: String,
        default: 'ratio',
      },
      key2: {
        type: String,
        default: 'warn',
      },
      // 字段一必填?
      isRequiredKey1: {
        type: Boolean,
        default: true,
      },
      isRequiredKey2: {
        type: Boolean,
        default: true,
      },
      // 是否禁用
      isDisabled: {
        type: Boolean,
        default: false,
      },
      // 初始化表单数据
      initFormData: {
        type: Array,
        default: () => [],
      },
      errorMessage: {
        type: String,
        default: '请填写完资料',
      },
      requireAtLeastOneRecord: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dynamicForm: {
          dynamicList: [],
        },
        isNumberValidator,
      };
    },
    methods: {
      addItem() {
        this.dynamicForm.dynamicList.push({ [this.key1]: '', [this.key2]: '' });
      },
      deleteItem(item) {
        if (this.requireAtLeastOneRecord && this.dynamicForm.dynamicList.length == 1) {
          this.$message.error(this.errorMessage);
          return;
        }
        const index = this.dynamicForm.dynamicList.indexOf(item);
        if (index !== -1) {
          this.dynamicForm.dynamicList.splice(index, 1);
        }
      },
      // TODO 测试提交
      async submitHandler() {
        try {
          const data = await this.getValidateFormData();
          console.log(data, '表单数据');
        } catch (e) {
          console.log(e);
        }
      },
      // 校验数据
      getValidateFormData() {
        return new Promise((resolve, reject) => {
          // if (this.requireAtLeastOneRecord && this.dynamicForm.dynamicList.length == 0) {
          //   this.$message.error('请填写回款约定');
          //   return;
          // }
          this.$refs.dynamicFormRef.validate((valid) => {
            if (valid) {
              resolve(this.dynamicForm.dynamicList);
            } else {
              this.$message.error(this.errorMessage);
              reject([]);
            }
          });
        });
      },
    },
    watch: {
      initFormData: {
        handler(newVal) {
          if (newVal && Array.isArray(newVal) && newVal.length) {
            this.dynamicForm.dynamicList = newVal.map((item) => {
              return {
                ...item,
                [this.key1]: item[this.key1],
                [this.key2]: item[this.key2],
              };
            });
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
